// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"337":"33f8bb2e","494":"33f8bb2e"}[chunkId] + ".chunk.css";
};